/**
 * LOGGER - Sistema de logging centralizado para Detectimáticas
 * Solo muestra mensajes en consola cuando DEBUG está habilitado.
 * 
 * USO:
 *   Logger.log('Mensaje normal');
 *   Logger.info('Información');
 *   Logger.warn('Advertencia');
 *   Logger.error('Error crítico'); // Siempre se muestra
 *   Logger.debug('Solo en modo debug');
 */

const Logger = {
    // Configuración - Cambiar a false para producción
    DEBUG: true, // TODO: Cambiar a false antes de desplegar

    // Prefijos con emojis para identificar rápidamente
    PREFIX: {
        log: '📝',
        info: 'ℹ️',
        warn: '⚠️',
        error: '❌',
        debug: '🔍',
        success: '✅'
    },

    /**
     * Log general - Solo en modo DEBUG
     */
    log(...args) {
        if (this.DEBUG) {
            console.log(this.PREFIX.log, ...args);
        }
    },

    /**
     * Información - Solo en modo DEBUG
     */
    info(...args) {
        if (this.DEBUG) {
            console.info(this.PREFIX.info, ...args);
        }
    },

    /**
     * Advertencia - Solo en modo DEBUG
     */
    warn(...args) {
        if (this.DEBUG) {
            console.warn(this.PREFIX.warn, ...args);
        }
    },

    /**
     * Error - SIEMPRE se muestra (crítico)
     */
    error(...args) {
        console.error(this.PREFIX.error, ...args);
    },

    /**
     * Debug detallado - Solo en modo DEBUG
     */
    debug(...args) {
        if (this.DEBUG) {
            console.log(this.PREFIX.debug, '[DEBUG]', ...args);
        }
    },

    /**
     * Éxito - Solo en modo DEBUG
     */
    success(...args) {
        if (this.DEBUG) {
            console.log(this.PREFIX.success, ...args);
        }
    },

    /**
     * Agrupa mensajes - Solo en modo DEBUG
     */
    group(label) {
        if (this.DEBUG) {
            console.group(label);
        }
    },

    groupEnd() {
        if (this.DEBUG) {
            console.groupEnd();
        }
    },

    /**
     * Tabla de datos - Solo en modo DEBUG
     */
    table(data) {
        if (this.DEBUG) {
            console.table(data);
        }
    },

    /**
     * Desactiva todos los logs (para producción)
     */
    disable() {
        this.DEBUG = false;
        console.log('🔇 Logger desactivado para producción');
    },

    /**
     * Activa los logs (para desarrollo)
     */
    enable() {
        this.DEBUG = true;
        console.log('🔊 Logger activado para desarrollo');
    }
};

// Exponer globalmente
window.Logger = Logger;

// Auto-detectar modo producción por hostname
if (window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1' &&
    !window.location.hostname.includes('netlify')) {
    // En producción, desactivar logs automáticamente
    Logger.disable(); 
}
